"use client";
import { useFormContext } from "react-hook-form";
import { useTranslations } from "next-intl";
import { CheckboxFormField } from "../../theme/components/Form";
import { Link } from "../../../navigation";
import FieldLabelWrapper from "../../common/components/form/FieldLabelWrapper";

const TermsField = ({ name = "acceptTerms" }) => {
  const t = useTranslations();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <FieldLabelWrapper
      className="color-primary-dimmed"
      label=""
      name={name}
      errorMessage={errors?.[name]?.message}
    >
      <CheckboxFormField
        name={name}
        {...register(name, {
          required: { value: true, message: t("accept_terms_required") },
        })}
        label={
          t.rich("accept_terms", {
            a: (chunk) => (
              <Link
                href={"/"}
                target="_blank"
                className="link"
                rel="noopener noreferrer"
              >
                {chunk}
              </Link>
            ),
            etag: (chunk) => (
              <Link
                target="_blank"
                className="link"
                rel="noreferrer"
                href="pages://64181909833711eea30c92f5"
              >
                {chunk}
              </Link>
            ),
          }) as string
        }
      />
    </FieldLabelWrapper>
  );
};

export default TermsField;
